export default "__VITE_ASSET__ee09288d__"